import { idb } from './idb';
import { withoutAgreementStamps } from './agreementView';
import type { ProvenanceSnapshot } from './passportProvenance';

/** Draft values and evidence share a transaction. The hash still detects legacy
 * or stale metadata; application/step keys prevent cross-context hydration. */
export const drafts = {
  key: (appId: string | number, stepKey: string) => `draft:${appId}:${stepKey}`,
  metaKey: (appId: string | number, stepKey: string) => `draftmeta:${appId}:${stepKey}`,
  acceptedKey: (appId: string | number, stepKey: string) => `acceptedmeta:${appId}:${stepKey}`,
  load: (appId: string | number, stepKey: string) =>
    idb.get<Record<string, unknown>>('drafts', drafts.key(appId, stepKey)),
  loadMeta: (appId: string | number, stepKey: string) =>
    idb.get<ProvenanceSnapshot>('drafts', drafts.metaKey(appId, stepKey)),
  loadAcceptedMeta: (appId: string | number, stepKey: string) =>
    idb.get<ProvenanceSnapshot>('drafts', drafts.acceptedKey(appId, stepKey)),
  /** Local capture history only, never Hub evidence or canonical values. The
   * caller invokes this after accepted save; hydration must verify valuesHash.
   * Logout's store wipe removes this alongside every other local draft key. */
  accept: (appId: string | number, stepKey: string, meta: ProvenanceSnapshot | null) =>
    idb.batch('drafts', [
      { key: drafts.key(appId, stepKey), delete: true },
      { key: drafts.metaKey(appId, stepKey), delete: true },
      meta
        ? { key: drafts.acceptedKey(appId, stepKey), value: meta }
        : { key: drafts.acceptedKey(appId, stepKey), delete: true },
    ]),
  save: (appId: string | number, stepKey: string, data: Record<string, unknown>, meta?: ProvenanceSnapshot | null) =>
    idb.batch('drafts', [
      { key: drafts.key(appId, stepKey), value: withoutAgreementStamps(data) },
      meta ? { key: drafts.metaKey(appId, stepKey), value: meta } : { key: drafts.metaKey(appId, stepKey), delete: true },
    ]),
  clear: (appId: string | number, stepKey: string) =>
    idb.batch('drafts', [
      { key: drafts.key(appId, stepKey), delete: true },
      { key: drafts.metaKey(appId, stepKey), delete: true },
    ]),
};